// src/components/InstaPlugWidget.js
import { useEffect } from "react";

export default function InstaPlugWidget() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.instaplug.app/platform/instaplug.js";
        script.async = true;
        script.onload = () => {
            window.renderApp({
                containerId: "cc27808a-18ab-4f2b-aec5-412f1d6af943",
                domain: "https://app.instaplug.app/",
                widgetClass: "",
                fontFamily: "",
                color: "",
                colorLink: "",
                colorLinkActive: "",
                colorLinkHover: "",
            });
        };
        document.body.appendChild(script);
    }, []);

    return <div id="cc27808a-18ab-4f2b-aec5-412f1d6af943"></div>;
}
